import { c as _c } from "react/compiler-runtime";
import { Maybe } from '@/utils/types';
import { useTranslation } from 'react-i18next';
interface Props {
  value: Maybe<string>;
}
export function Employment(t0) {
  const $ = _c(6);
  const {
    value
  } = t0;
  const {
    t
  } = useTranslation("career");
  switch (value) {
    case "fulltime":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("employment.fulltime");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "parttime":
      {
        let t1;
        if ($[2] !== t) {
          t1 = t("employment.parttime");
          $[2] = t;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "internship":
      {
        let t1;
        if ($[4] !== t) {
          t1 = t("employment.internship");
          $[4] = t;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}